// Module Import
//---------------------------------
import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React, { useState, useEffect, useRef } from 'react'

import styled from 'styled-components'
import Slider from 'react-slick'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import Image from '../../atoms/images/images'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import ImagePalceholder from '../../../assets/images/placeholder_image_icon.svg'
import {brandIvory, brandOrange} from '../../../assets/consts/color'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { getYouTubeVideoId } from '../../../helpers/getYouTubeVideoId'
import ArrowIco from "../../../assets/images/icon_arrowBlack.png";

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const ProductCarouselBody = styled.div`
  margin: 0 0 24px 0;
  position: relative;

  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    bottom: 0;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    width: 60px;
    z-index: 1;
  }

  .slick-slide {
    & > div {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      & > div {
        width: 100%;
        height: 100%;
      }
    }
  }
    
  .slick-arrow {
      //background: ${brandOrange};
      height: 30px;
      border-radius: 8px;
      width: 30px;
      opacity: .7;
      z-index: 999;
      transition: .2s ease-in-out;
      display: grid !important;
      place-content: center;
      
      &.slick-prev {
          left: -34px;
            
          &:before {
              position: relative;
              content: "";
              background-image: url(${ArrowIco});
              background-repeat: no-repeat;
              background-size: contain;
              background-position: 50% 50%;
              height: 26px;
              width: 26px;
              display: block;
              rotate: 180deg;
          }
      }
      
      &.slick-next { 
          right: -34px;
          
          &:before {
              position: relative;
              content: "";
              background-image: url(${ArrowIco});
              background-repeat: no-repeat;
              background-size: contain;
              background-position: 50% 50%;
              height: 26px;
              width: 26px;
              display: block;
          }
      }
      
      &:before, &:after {
          font-size: 20px;
          line-height: 10px;
      }
      
      &:focus {
          opacity: .7;
          
          //background: ${brandOrange};
      }
      
      &:hover, &:focus:hover {
          background: ${brandOrange};
          opacity: 1;
      }

      @media screen and (max-width: 1024px) {
          display: none;
      }
  }  
`

const ProductCarouselFooter = styled.div`
    .slick-arrow {
       display: none;
    }
`

const SingleImageFrame = styled.div`
  background-color: ${brandIvory};
  aspect-ratio: 1/1;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 40px;

  img {
    mix-blend-mode: multiply;
  }

  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    bottom: 0;
    content: '';
    height: 60px;
    position: absolute;
    right: 0;
    width: 60px;
    z-index: 1;
  }
`
const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  & .video,
  & video {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

// Component Export
//---------------------------------
function ProductGallery({ carouselImages, productTitle }) {
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let sliderRef1 = useRef(null)
  let sliderRef2 = useRef(null)

  useEffect(() => {
    setNav1(sliderRef1)
    setNav2(sliderRef2)
  }, [])
  return (
    <>
      {' '}
      {carouselImages === undefined || carouselImages.length === 0 ? (
        <SingleImageFrame>
          <img src={ImagePalceholder} alt={productTitle || 'No Image'} />
        </SingleImageFrame>
      ) : (
        <div className="slider-container">
          {carouselImages.length < 2 ? (
            <SingleImageFrame>
              <ImageOrVideoItem item={carouselImages[0]} productTitle={productTitle} />
            </SingleImageFrame>
          ) : (
            <>
              <ProductCarouselBody>
                <Slider
                  className="mainCarousel"
                  asNavFor={nav2}
                  ref={(slider) => (sliderRef1 = slider)}
                >
                  {carouselImages.map((target, index) => (
                    <div key={index}>
                      <ImageOrVideoItem
                        item={target}
                        productTitle={productTitle}
                        itemIndex={index}
                      />
                    </div>
                  ))}
                </Slider>
              </ProductCarouselBody>
              <ProductCarouselFooter>
                <Slider
                  className="navCarousel"
                  asNavFor={nav1}
                  ref={(slider) => (sliderRef2 = slider)}
                  slidesToShow={4}
                  swipeToSlide
                  focusOnSelect
                >
                  {carouselImages.map((target, index) => (
                    <div key={index}>
                      <Image
                        imgSrc={
                          target.preview
                            ? target.preview?.image.gatsbyImageData
                            : target.gatsbyImageData
                        }
                        altTag={`${productTitle || target.alt || target.description}${index > 0 ? ` Photo ${index + 1}` : ''}`}
                        title={`${productTitle || target.alt || target.description}${index > 0 ? ` Photo ${index + 1}` : ''}`}
                        hasFrame="No Frame"
                        aspectRatio="None"
                        loading="eager"
                      />
                    </div>
                  ))}
                </Slider>
              </ProductCarouselFooter>
            </>
          )}
        </div>
      )}
    </>
  )
}

function ImageOrVideoItem({ item, productTitle, itemIndex }) {
  const isMobile = useIsMobile()

  const videoUrl = item?.sources?.[0]?.url || item?.embeddedUrl

  if (videoUrl) {
    const youTubeVideoId = getYouTubeVideoId(videoUrl)
    if (youTubeVideoId) {
      return (
        <VideoWrapper>
          <iframe
            src={`https://www.youtube.com/embed/${youTubeVideoId}`}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoWrapper>
      )
    }

    return (
      <VideoWrapper>
        <video controls>
          <source src={videoUrl} />
        </video>
      </VideoWrapper>
    )
  }

  return (
    <Zoom zoomMargin={isMobile ? 5 : 45} classDialog="custom-zoom">
      <Image
        imgSrc={item.preview ? item.preview?.image.gatsbyImageData : item.gatsbyImageData}
        altTag={`${productTitle || item.alt || item.description}${itemIndex > 0 ? ` Photo ${itemIndex + 1}` : ''}`}
        title={`${productTitle || item.alt || item.description}${itemIndex > 0 ? ` Photo ${itemIndex + 1}` : ''}`}
        hasFrame="No Frame"
        aspectRatio="None"
        loading="eager"
      />
    </Zoom>
  )
}

export default ProductGallery

ProductGallery.propTypes = {}
